/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import Toggle from 'react-toggle'

import mobileLogoAnimated from '@/assets/gifs/interact-grey.gif'

function MobileSourceNode({ data, isConnectable }) {
  const SetHeaterState = (e) => {
    data.changeHeaterState()
  }
  return (
    <div className="custom-node-wbg robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={mobileLogoAnimated} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Mobile App</b>
          </div>
          <div className="text-center">
            <Toggle id="heater-status" defaultChecked={data.heaterState} onChange={data.onChange} />
          </div>
        </div>
      </div>

      <Handle id="a" type="source" position={Position.Right} />
      <Handle id="b" type="source" position={Position.Bottom} />
    </div>
  )
}

export default MobileSourceNode
